(() => {
  const popups = document.querySelectorAll('.gx-pop[data-gx-type]');
  if (!popups.length) return;

  const now = () => Date.now();
  const daysToMs = (d) => d * 24 * 60 * 60 * 1000;
  const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

  // ---- cart cache (so we don't spam /cart.js) ----
  let cartPromise = null;

function getCart() {
  if (!cartPromise) {
    cartPromise = fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .catch(() => ({ item_count: 0, items: [] })); // fail-safe
  }
  return cartPromise;
}
  function refreshCartCache() {
  cartPromise = null;
}

async function getCartFresh() {
  try {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!r.ok) throw new Error('cart fetch failed');
    return await r.json();
  } catch (e) {
    return { item_count: 0, items: [] };
  }
}

  function getUntil(key) {
    const v = localStorage.getItem(key);
    const n = v ? Number(v) : 0;
    return Number.isFinite(n) ? n : 0;
  }

  function setUntil(key, days) {
    localStorage.setItem(key, String(now() + daysToMs(days)));
  }

  function validateEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || "").trim());
  }

  function initPopup(root) {
    const type = root.dataset.gxType;

    const KEY_DISMISS = type === 'home-email' ? 'gx_home_dismiss_until' : 'gx_exit_dismiss_until';
    const KEY_SUCCESS = type === 'home-email' ? 'gx_home_success_until' : 'gx_exit_success_until';

    const dismissDays = Number(root.dataset.dismissDays || 7);
    const successDays = Number(root.dataset.successDays || 30);

    const dialog = root.querySelector('.gx-pop__dialog');
    const overlay = root.querySelector('.gx-pop__overlay');
    const closeEls = root.querySelectorAll('[data-gx-close]');

    let lastActive = null;

    function getFocusable() {
      return dialog.querySelectorAll(
        'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
      );
    }

    function onKeydown(e) {
      if (e.key === 'Escape') return close(true);

      if (e.key === 'Tab') {
        const focusables = Array.from(getFocusable());
        if (!focusables.length) return;

        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    }

    function open() {
      // prevent two popups overlapping
      document.querySelectorAll('.gx-pop.gx-open').forEach(p => {
        if (p !== root) p.classList.remove('gx-open');
      });

      lastActive = document.activeElement;
      root.classList.add('gx-open');
      root.setAttribute('aria-hidden', 'false');
      dialog.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close(markDismiss = true) {
      root.classList.remove('gx-open');
      root.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);

      if (markDismiss) setUntil(KEY_DISMISS, dismissDays);

      if (lastActive && typeof lastActive.focus === 'function') lastActive.focus();
    }

    closeEls.forEach(el => el.addEventListener('click', () => close(true)));
    overlay?.addEventListener('click', () => close(true));

    function shouldShowByCooldown() {
      if (getUntil(KEY_SUCCESS) > now()) return false;
      if (getUntil(KEY_DISMISS) > now()) return false;
      return true;
    }

    // ======================
    // HOME EMAIL POPUP
    // ======================
    if (type === 'home-email') {
      const delayMs = Number(root.dataset.delayMs || 3000);
      const form = root.querySelector('#gxHomeForm');
      const stateEl = root.querySelector('#gxHomeState');
      const btn = root.querySelector('#gxHomeSubmit');
      const emailErr = root.querySelector('[data-gx-error="email"]');

      if (form) {
        form.addEventListener('submit', (e) => {
          emailErr.textContent = "";
          stateEl.textContent = "";

          const email = (form.querySelector('input[name="contact[email]"]')?.value || "").trim();

          if (!email) {
            e.preventDefault();
            emailErr.textContent = "Please enter your email address.";
            return;
          }
          if (!validateEmail(email)) {
            e.preventDefault();
            emailErr.textContent = "Please enter a valid email address.";
            return;
          }

          // mark success cooldown (Shopify form may reload page)
          localStorage.setItem(KEY_SUCCESS, String(now() + daysToMs(successDays)));
          localStorage.removeItem(KEY_DISMISS);

          btn.disabled = true;
          btn.textContent = "Submitting…";
          stateEl.textContent = "✅ You’re in! Deals will reach you soon.";
        });
      }

      if (isDesignMode) return;

      window.addEventListener('load', () => {
        setTimeout(() => { if (shouldShowByCooldown()) open(); }, delayMs);
      }, { once: true });

      return;
    }

    // ======================
    // EXIT SAVINGS POPUP (ONLY if cart has exactly 1 item)
    // ======================
    if (type === 'exit-savings') {
      const triggerMode = root.dataset.trigger || 'exit-intent';
      const primaryBtn = root.querySelector('[data-gx-primary]');

      // Desktop-only exit intent
      const desktop = window.matchMedia && window.matchMedia('(pointer:fine)').matches;

      // If cart changes (add/remove), we want fresh item_count next time
      // (Trade theme cart drawer usually triggers cart refresh; this is a safe fallback)
      document.addEventListener('cart:refresh', refreshCartCache);

      async function shouldShowExit() {
        if (!desktop) return false;
        if (!shouldShowByCooldown()) return false;

        const cart = await getCartFresh();
        // ✅ core requirement: show only when cart has EXACTLY 1 item
        return Number(cart?.item_count || 0) === 1;
      }

      async function maybeOpenExit() {
        const ok = await shouldShowExit();
        if (ok) open();
      }

      // Primary CTA: send them to deals page (or keep as /cart if you prefer)
      primaryBtn?.addEventListener('click', async () => {
        localStorage.setItem(KEY_SUCCESS, String(now() + daysToMs(successDays)));
        localStorage.removeItem(KEY_DISMISS);
        window.location.href = '/collections/under-399';
      });

      if (isDesignMode) return;

      let fired = false;

      // Exit intent = cursor leaves from top
      document.addEventListener('mouseout', async (e) => {
        if (fired) return;
        if (e.clientY <= 0) {
          fired = true;
          await maybeOpenExit();
        }
      });

      // Optional soft-exit
      if (triggerMode === 'soft-exit') {
        document.addEventListener('visibilitychange', async () => {
          if (fired) return;
          if (document.visibilityState === 'hidden') {
            fired = true;
            await maybeOpenExit();
          }
        });
      }

      return;
    }
  }

  popups.forEach(initPopup);
})();
